import { MS_THEME } from '../components/AppWrapper/constants'

// DWB launches with theme=gradems regardless of grade and has no dedicated
// theme module. Map it to grade8 so consumers (done slide, etc.) resolve.
export const THEME_ALIASES = {
  [MS_THEME]: 'grade8',
}

export const resolveThemeId = themeId =>
  (themeId && THEME_ALIASES[themeId]) || themeId

export const getGradeFromThemeParam = () => {
  const { search } = window.location || {}
  const params = search && new URLSearchParams(search)

  if (params?.get) {
    const theme = params.get('theme')
    return theme ? resolveThemeId(theme) : null
  }
  // satisfy unit test case:
  return null
}
